import { globalStyleSheet } from "@/assets/css/global";
import closeIcon from '@/assets/images/close.svg';
const styleSheet = new CSSStyleSheet();
styleSheet.replaceSync(`
    :host {
        display: flex;
        width: 24px;
        height: 24px;
    }
    
    button {
        height: 100%;
        width: 100%;
        background-color: transparent;
        padding: 0;
        outline: 0;
     }
`);
export class RCloseButton extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' }).adoptedStyleSheets = [globalStyleSheet, styleSheet];
    }
    connectedCallback() {
        this.#initDOM();
    }
    #initDOM() {
        this.shadowRoot.innerHTML = `
            <button>
                <r-icon url="${closeIcon}"></r-icon>
            </button>
        `;
    }
}
customElements.define('r-close-button', RCloseButton);
